<template>

  <div class="top-bar">
    <div class="top-right">
      <!--图片下载-->
      <span style="margin-right: 12px" @click="download">
            <img style="width: 1rem; margin-top: -0.35rem; vertical-align: middle;"
                 src="/static/img/img.png"/>
      </span>

      <!--切换语言-->
      <span @click="switchLanguage()">
            <img style="width: 0.9rem; margin-top: -0.35rem; vertical-align: middle;"
                 src="/static/img/switch.png"/>
            <span style="font-size: 1rem; margin-left: 0.3rem;">{{ langName }}</span>
      </span>
    </div>

  </div>

  <div class="list-title">
    <!--错误名称-->
    <div class="list-title-item">{{ t('errorName') }}</div>

    <!--图示-->
    <div class="list-title-item">{{ t('illustration') }}</div>

    <!--错误代码-->
    <div class="list-title-item">{{ t('errorCode') }}</div>
  </div>
  <div style="width: 100%; height:5px; background: #eff2f5"></div>

  <van-pull-refresh
      :pulling-text="t('pullingText')"
      :loosing-text="t('loosingText')"
      :loading-text="t('loadingText')"
      style="min-height: 90vh;"
      v-model="isLoading"
      @refresh="onRefresh">


    <van-empty v-if="errorList.length === 0" :description="t('emptyTxt')"/>
    <van-grid v-for="item in errorList" :key="item.id || errorList.indexOf(item)" direction="horizontal"
              :column-num="3">
      <van-grid-item>
        <div class="list-title-data">
          <!--中文标题-->
          <div style="font-size: 15px">
            {{ item.errorName }}
          </div>

          <!--英文标题-->
          <div style="font-size: 15px; margin-top: 5px">
            {{ item.errorNameCn }}
          </div>
        </div>
      </van-grid-item>

      <!--展示图形-->
      <van-grid-item>
        <img style="width: 100%; height: auto"
             :src="item.itemImg" :show-loading="true" :alt="item.errorNameCn">
      </van-grid-item>

      <!--错误代码-->
      <van-grid-item><span style="font-size: 26px">{{ item.hexErrorCode }}</span></van-grid-item>
    </van-grid>

    <div style="width: 100%; height:2px; background: #eff2f5"></div>

    <!--加载更多-->
    <div v-if="showMore && errorList.length > 0" @click="loadMoreApi" class="load-more">
      -- {{ t('loadMore') }} --
    </div>
  </van-pull-refresh>

  <!--回到顶部-->
  <van-back-top style="background: rgb(248, 140, 109);" right="3vw" bottom="10vh"/>

  <!--加载动画-->
  <div v-if="isWait" class="wait-body">
    <van-loading style="margin-top: 50vh;" color="#0094ff" type="spinner"/>
  </div>

</template>

<script setup>
import {ref, onMounted} from 'vue';
import {useI18n} from 'vue-i18n'
import {getErrorPage} from '@/api/app/index'

const urlParams = new URLSearchParams(window.location.search);
const model = urlParams.get('model');

const {t, locale} = useI18n()
//默认是英文
const lang = ref('en')
const langName = ref('CN')

//加载动画状态
const isWait = ref(false)

const switchLanguage = () => {
  if (lang.value === 'en') {
    lang.value = 'zh'
    langName.value = 'EN'
  } else {
    lang.value = 'en'
    langName.value = 'CN'
  }
  locale.value = lang.value
}
//刷新状态
const isLoading = ref(false);

//还有更多数据
const showMore = ref(true)

//数据列表
const errorList = ref([])

//下拉刷新
function onRefresh() {
  pageNumber.value = 1;
  errorList.value = []
  getErrorList()

}

function download() {
  window.open("https://vinkalife-1255635395.cos.ap-hongkong.myqcloud.com/img/app/display-error-list-" + lang.value + ".jpg", '_blank')
}

const pageNumber = ref(1);

//页面加载完成执行
onMounted(() => {
  getErrorList()
})

//获取仪表错误列表
function getErrorList() {
  isWait.value = true;
  getErrorPage({
    pageNumber: pageNumber.value,
    pageSize: 10,
    errorModel: 2,
    model: model
  })
      .then(res => {
        if (res.code === 10200) {
          pageNumber.value = pageNumber.value + 1;
          if (pageNumber.value > res.data.pages) {
            // 没有更多数据
            showMore.value = false;
          } else {
            showMore.value = true;
          }
        }
        //追加到errorList列表底部
        errorList.value = errorList.value.concat(res.data.records);
        console.log(res)
      })
      .finally(() => {
        isLoading.value = false;
        isWait.value = false;
      })
  console.log("获取错误列表" + pageNumber.value)
}

//加载更多
function loadMoreApi() {
  getErrorList()
}

</script>


<style>
.list-title {
  width: 100%;
  background: #ffffff;
  display: flex;
}

.list-title-item {
  flex: 1; /* 平均分配三个项目的空间 */
  text-align: center;
  padding: 10px 0;
  font-weight: bold; /* 可选：加粗标题 */
  border-right: 1px solid #eff2f5;
}

.top-bar {
  background: linear-gradient(90deg, rgb(248, 140, 109), rgb(220, 56, 73));
  height: 3rem;
  width: 100%;
}

.top-right {
  float: right;
  margin-top: 1rem;
  margin-right: 1rem;
  color: white;
}

.load-more {
  text-align: center;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  color: #999999;
  font-size: 0.8rem;
  cursor: pointer;
}

.wait-body {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0px;
  background: rgba(2, 2, 2, 0.5);
  text-align: center;
}

.list-title-data {
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  overflow-wrap: break-word;
}

</style>
